import { render, staticRenderFns } from "./sx_identify.vue?vue&type=template&id=76690a5f&scoped=true"
import script from "./sx_identify.vue?vue&type=script&lang=js"
export * from "./sx_identify.vue?vue&type=script&lang=js"
import style0 from "./sx_identify.vue?vue&type=style&index=0&id=76690a5f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76690a5f",
  null
  
)

export default component.exports